var exports = {
  "jw": "chip__JBfL9n",
  "bG": "interactive__v_eA40",
  "pW": "leadingVisual__4VZ0G_",
  "Pf": "label__hBQYdg",
  "bH": "wrapLabel__yFhnV0",
  "LX": "trailingVisual__77G20A",
};

module.exports = exports;
